import _get from 'lodash/get';

export const getPopupData = state => _get(state, 'popup.popupData');
